import { isZodLiteralValue } from '@plato/shared-util/codecs';
import { z } from 'zod';

export function conditionToZodSchema(value: unknown): z.ZodType {
    if (value === undefined) {
        return z.undefined();
    }
    if (value === null) {
        return z.null();
    }
    if (isZodLiteralValue(value)) {
        return z.literal(value);
    }

    if (typeof value !== 'object') {
        throw new Error(
            `Unsupported condition of type "${typeof value}" with value ${JSON.stringify(value)}`,
        );
    }

    if (Array.isArray(value)) {
        if (value.length === 0) {
            return z.array(z.never()).max(0).nullable().optional();
        } else if (value.length === 1) {
            return z.array(conditionToZodSchema(value[0])).min(1);
        } else {
            return z.array(z.union(value.map((v) => conditionToZodSchema(v)))).min(1);
        }
    }

    const shape = Object.fromEntries(
        Object.entries(value).map(([key, val]) => [key, conditionToZodSchema(val)]),
    );
    return z.looseObject(shape);
}
